import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MsalService } from '@azure/msal-angular';
import { UserInfo } from './models/user-info.model';
import { NotificationService } from './services';
import { IdleService } from './services/idle.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  user: UserInfo;

  title = 'AzureMSALAngular';
  errorMessage: any;
  private statusInterval: ReturnType<typeof setInterval>;

  constructor(
      private notificationsService: NotificationService,
      private authService: MsalService,
      private idleService: IdleService,
      private titleService: Title
  ) { }

  async ngOnInit() {
    this.titleService.setTitle(environment.appTitle);

    if (sessionStorage.getItem('isLogged') === null) {
      sessionStorage.setItem('isLogged', 'true');
    }

    this.statusInterval = setInterval(() => {
      this.notificationsService.intervalUpdateExecutionStatus(true);
    }, 100000);
  }

  ngOnDestroy() {
    clearInterval(this.statusInterval);
  }

}
